import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../lib/analytics';

export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const previousPathRef = useRef(`${location.pathname}${location.search}`);

  useEffect(() => {
    const nextPath = `${location.pathname}${location.search}`;

    if (previousPathRef.current === nextPath) {
      return;
    }

    previousPathRef.current = nextPath;
    trackPageView(nextPath, document.title);
  }, [location.pathname, location.search]);

  return null;
}
